module.exports = __webpack_public_path__ + "static/media/sliderSeven.525ab954.png";